import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RequestService } from 'src/app/onelog/services/request.service';
import { VALIDATE_TOKEN_RECEVIED_FROM_SACH_URL } from '../config/url';
import { UserDetailsService } from 'src/app/onelog/services/user-details.service';
import { prefixReport } from '../config/url-prefix';

@Component({
  selector: 'app-auth-from-sach',
  templateUrl: './auth-from-sach.component.html',
  styleUrls: ['./auth-from-sach.component.css'],
})
export class AuthFromSachComponent {
  user: any = '';
  token: any = '';
  redirectLink: any = '';
  prefixReport: string = prefixReport;
  constructor(
    private route: ActivatedRoute,
    private requestService: RequestService,
    private userService: UserDetailsService,
    private router: Router
  ) {}

  ngOnInit() {
    console.log(1);
    this.user = this.route.snapshot.paramMap.get('user');
    this.token = this.route.snapshot.paramMap.get('token');
    this.redirectLink = this.route.snapshot.paramMap.get('redirectTo');
    this.checkToken();
  }

  checkToken() {
    this.requestService
      .postCheckToken(
        VALIDATE_TOKEN_RECEVIED_FROM_SACH_URL,
        [],
        '',
        this.user,
        this.token
      )
      .subscribe((data: any) => {
        this.userService.setUserDetails(data.token, data.user, data.user);
        console.log(`/${this.redirectLink}`);
        this.router.navigate([`/${prefixReport}/${this.redirectLink}`]);
      });
  }
}
